import React from 'react';
import { Table, ButtonGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { statistics } from '../../services/ApiService';
import { startSetStatistics, startSetDictionary } from '../../actions/statistics';
import { FMessage } from '../../hoc/IntlComponents';
import moment from 'moment';
import numeral from 'numeral';
import { currencyToSign } from '../../utils/utils';

class DashboardStatTable extends React.Component {
  state = {
    loading: false,
    type: 'offers',
    dictionary: {
      offers: [],
      flows: [],
      sources: [],
    },
    tabs: {
      offers: [],
      flows: [],
      sources: [],
    },
    offers: [],
    flows: [],
    sources: [],
    currency: 0, // 0 RUB, 1 USD, 2 EUR
  };

  componentDidMount() {
    this.getStat();
  }

  formatCurrency = () => {
    switch (this.state.currency) {
      case 0:
        return 'rub';
      case 1:
        return 'usd';
      case 2:
        return 'eur';
      default:
        break;
    }
  };

  formatPeriod = () => {
    const { period } = this.props;
    switch (period) {
      case 'day':
        return {
          dateFrom: moment()
            // .subtract(1, 'days')
            .format('DD.MM.YYYY'),
          dateTo: moment().format('DD.MM.YYYY'),
        };
      case 'week':
        return {
          dateFrom: moment().subtract(6, 'days').format('DD.MM.YYYY'),
          dateTo: moment().format('DD.MM.YYYY'),
        };
      case 'month':
        return {
          dateFrom: moment().subtract(1, 'month').format('DD.MM.YYYY'),
          dateTo: moment().format('DD.MM.YYYY'),
        };
      default:
        break;
    }
  };

  getStat = () => {
    const { type, currency } = this.state;
    const { statistic } = this.props;

    const period = this.formatPeriod();

    this.setState(
      () => ({ loading: true }),
      () => {
        statistics
          .getStats(statistic === 'general' ? this.getReqType(type) : this.getSpReqType(type), {
            ...period,
          })
          .then((data) => {
            const { tabs, items } = data;
            this.setState(
              (prevState) => ({
                ...prevState,
                [type]: items,
                tabs: {
                  ...prevState.tabs,
                  [type]: tabs,
                },
              }),
              () => {
                const params = this.state[type]
                  .map((item) => item[this.getTypeId(type)][currency])
                  .join(',');
                this.props.startSetDictionary(type, { ids: params }).then(({ dictionary }) => {
                  this.setState((prevState) => ({
                    loading: false,
                    dictionary: {
                      ...prevState.dictionary,
                      [type]: dictionary[type],
                    },
                  }));
                });
              },
            );
          });
      },
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.type !== prevState.type ||
      this.props.period !== prevProps.period ||
      this.props.statistic !== prevProps.statistic
    ) {
      this.getStat();
    }
  }

  getTypeId = (type) => {
    switch (type) {
      case 'offers':
        return 6;
      case 'flows':
        return 5;
      case 'sources':
        return 7;
      default:
        break;
    }
  };

  getReqType = (type) => {
    switch (type) {
      case 'offers':
        return 'dashOffers';
      case 'flows':
        return 'dashFlows';
      case 'sources':
        return 'dashSources';
      default:
        break;
    }
  };
  // feature/OFFERRUM-2362 for Sp statistics
  getSpReqType = (type) => {
    switch (type) {
      case 'offers':
        return 'dashOffersSp';
      case 'flows':
        return 'dashFlowsSp'; // 여기에 Sp 뒤에 추가해야 함.
      case 'sources':
        return 'dashSourcesSp'; // 여기에 Sp 뒤에 추가해야 함.
      default:
        break;
    }
  };
  getItemPath = (type) => {
    switch (type) {
      case 'offer_id':
        return 'offers';
      case 'stream_id':
        return 'tools/flows';
      default:
        return null;
    }
  };

  renderStat = () => {
    const { dictionary, type, currency, tabs } = this.state;

    const headers = tabs[type].map(({ id, type }) => ({ id, type }));

    const rows = this.state[type]
      .filter((item) => {
        return (
          headers
            .map((header) => {
              if (header.id !== this.getTypeId(type)) {
                return item[header.id][currency];
              }
            })
            .filter((num) => num).length > 0
        );
      })
      .sort((a, b) => {
        if (a[31][currency] > b[31][currency]) {
          return -1;
        } else if (b[31][currency] > a[31][currency]) {
          return 1;
        } else {
          return 0;
        }
      })
      .map((item, index) => {
        return (
          <tr key={index}>
            {headers.map((header, idx) => {
              if (header.id === this.getTypeId(type)) {
                const itemId = item[header.id][currency];
                const itemInfo = dictionary[type].find((dictItem) => {
                  return dictItem.id === itemId;
                });
                const path = this.getItemPath(header.type);

                if (itemInfo && itemInfo.title) {
                  return path ? (
                    <td key={idx}>
                      <Link to={`/${path}/${itemInfo.id}`}>{itemInfo.title}</Link>
                    </td>
                  ) : (
                    <td key={idx}>{itemInfo.title}</td>
                  );
                } else {
                  return <td key={idx}>—</td>;
                }
              } else if (header.type === 'money') {
                return (
                  <td className="dashboard-stat-table-value text-right" key={idx}>
                    {numeral(item[header.id][currency]).format('0,000.00')}
                    {'\u00a0'}
                    {currencyToSign(this.formatCurrency())}
                  </td>
                );
              } else {
                return (
                  <td className="dashboard-stat-table-value text-right" key={idx}>
                    {item[header.id][currency]}
                  </td>
                );
              }
            })}
          </tr>
        );
      });
    return rows.length > 0 ? (
      rows
    ) : (
      <tr className="no-data">
        <td className="py-5" colSpan="5">
          <FMessage id="statistics.table.no-data" />
        </td>
      </tr>
    );
  };

  render() {
    const { type, tabs, dictionary, currency, loading } = this.state;
    return (
      <>
        <div className="dashboard-stat-table-controls d-flex flex-column flex-sm-row align-items-center justify-content-between">
          <ButtonGroup className="currencies w-100 btn-switcher">
            <button
              className={type === 'offers' ? 'active' : ''}
              onClick={() => this.setState({ type: 'offers' })}
            >
              <FMessage id="statistics.filters.offers" />
            </button>
            <button
              className={type === 'sources' ? 'active' : ''}
              onClick={() => this.setState({ type: 'sources' })}
            >
              <FMessage id="statistics.filters.sources" />
            </button>
            <button
              className={type === 'flows' ? 'active' : ''}
              onClick={() => this.setState({ type: 'flows' })}
            >
              <FMessage id="statistics.filters.flows" />
            </button>
          </ButtonGroup>
          {/* <ButtonGroup className="currencies">
            <Button
              className={currency === 0 ? 'active' : ''}
              size="sm"
              onClick={() => this.setState({ currency: 0 })}
              color="primary"
              outline={currency !== 0}
            >
              RUB
            </Button>
            <Button
              className={currency === 1 ? 'active' : ''}
              size="sm"
              onClick={() => this.setState({ currency: 1 })}
              color="primary"
              outline={currency !== 1}
            >
              USD
            </Button>
            <Button
              className={currency === 2 ? 'active' : ''}
              size="sm"
              onClick={() => this.setState({ currency: 2 })}
              color="primary"
              outline={currency !== 2}
            >
              EUR
            </Button>
          </ButtonGroup> */}
        </div>
        {loading ? (
          <p className="py-5 text-center">
            <FMessage id="statistics.table.loading" />
          </p>
        ) : (
          <div className="dashboard-stat-table">
            <Table size="sm" responsive>
              <thead>
                <tr>
                  {tabs &&
                    tabs[type] &&
                    tabs[type].map(({ title, id }) => (
                      <td className={this.getTypeId(type) !== id ? 'text-right' : ''} key={id}>
                        {title}
                      </td>
                    ))}
                </tr>
              </thead>
              <tbody>{dictionary && dictionary[type] && this.renderStat()}</tbody>
            </Table>
          </div>
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startSetStatistics: (params) => dispatch(startSetStatistics(params)),
  startSetDictionary: (type, params) => dispatch(startSetDictionary(type, params)),
});

export default connect(null, mapDispatchToProps)(DashboardStatTable);
